import { render } from "./year.vue?vue&type=template&id=283028f2&scoped=true"
import script from "./year.vue?vue&type=script&lang=js"
export * from "./year.vue?vue&type=script&lang=js"

import "./year.vue?vue&type=style&index=0&id=283028f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283028f2"]])

export default __exports__